import { axiosInstance } from "../../../config/axios";
import endpoints from "../../../config/endpoints";
import { GenericResponse } from "../../../types";

export interface SMS {
    id: number;
    created_at: string;
    updated_at: string;
    deleted_at: string;
    phone_number: string;
    direction: string;
    body: string;
    timestamp: string;
    message_sid: string;
}


export const getSMS = async (params: { page: number; limit: number }): Promise<GenericResponse<SMS[]>> => {
	const response = await axiosInstance.get<GenericResponse<SMS[]>>(
		`${import.meta.env.PROD ? endpoints().messaging.getSMS : `/api/v1${endpoints().messaging.getSMS}`}`,
		{ params },
	);
	return response.data;
};

export const getSMSByUserId = async (userId: number): Promise<GenericResponse<SMS[]>> => {
    const response = await axiosInstance.get<GenericResponse<SMS[]>>(
        `${import.meta.env.PROD ? endpoints(userId).messaging.getSMSByUserId : `/api/v1${endpoints(userId).messaging.getSMSByUserId}`}`,
    );
    return response.data;
};

export const downloadSMS = async (
    params?: { 
        user_id: number,
        format: 'json' | 'csv' | 'txt'
    }
): Promise<Blob> => {
    const response = await axiosInstance.get<Blob>(
        `${import.meta.env.PROD ? endpoints().messaging.downloadSMS : `/api/v1${endpoints().messaging.downloadSMS}`}`,
        {
            params,
            responseType: 'blob',
        },
    );
    return response.data;
};